import Rockets from '../components/Rockets/Rockets';

const RocketsPage = () => (
  <Rockets />
);

export default RocketsPage;
